module.exports = __webpack_public_path__ + "login_background.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_background.png
// module id = 44
// module chunks = 0